import React from "react";
import { Rating } from "semantic-ui-react";
import "./styles.css";

const QUESTION_TEXT = "How many stars would you give it? (*)";

export default class StarRating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
    };
  }

  handleSelect(event, data) {
    this.setState({ selected: data.rating });
    this.props.handleSelected(data.rating);
  }

  render() {
    return (
      <div className="star-wrapper" style={this.props.style}>
        {!this.props.disableLabel && (
          <span className="label">{QUESTION_TEXT}</span>
        )}
        <Rating
          size="massive"
          onRate={(event, data) => this.handleSelect(event, data)}
          className="rating"
          icon="star"
          defaultRating={this.props.value || 0}
          maxRating={5}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StarRating/StarRating.jsx